import request from '@/utils/request'
import uploadFile from '@/utils/uploadFile'
import entranceUploadFile from '@/utils/entranceUploadFile.js'

// 公共入口
const service = params => request.post('/services/query_service', params);
const upload_file = params => uploadFile.post('/services/upload_service', params);
const entrance_upload_file = params => entranceUploadFile.post('/services/upload_admin_service', params);
const avatar_upload_file = params => entranceUploadFile.post('/services/upload_admin_service?type=1', params);


export default {
    service,
    upload_file,
    entrance_upload_file,
    avatar_upload_file,
}
